/* EQUALIZER - VERTICAL CENTER
 *
 * Set up Equalizer to add vertical-center from data-attribute
*/
jQuery( '[data-equalize-vertical-center]' ).on( 'postequalized.zf.equalizer', function(){
    var targetClass = '.' + jQuery( this ).data( 'equalize-vertical-center' );
    jQuery( this ).find( targetClass ).addClass( 'vertical-center-large' );
});

/* HAMBURGER
 *
 * */
jQuery( 'body' ).on( 'closed.zf.offcanvas', function(){
    jQuery( '#menu-hamburger' ).removeClass( 'is-active' );
});

/* OFFCANVAS
 *
 * */
jQuery( 'body' ).on( 'opened.zf.offcanvas', function(){
    jQuery( '.off-canvas-content' ).addClass( 'is-open' );
});
jQuery( 'body' ).on( 'closed.zf.offcanvas', function(){
    jQuery( '.off-canvas-content' ).removeClass( 'is-open' );
});

/* FLICKITY
 *
 * */
var autoplayCount = 0;

var setUpSliders = function(){
    var fpSlider = jQuery( '.front-page-slider' ),
        blockSlider = jQuery( '.carousel-block' ),
        headerSlider = jQuery( '.header-slider' ),
        specialsSlider = jQuery( '.specials-slider' );

    if( fpSlider.length ){
        fpSlider.flickity({ // options
            cellSelector: '.carousel-slide',
            prevNextButtons: false,
            wrapAround: true,
            autoPlay: 4000,
            selectedAttraction: 0.01,
            friction: 0.35
        });
    }

    if( blockSlider.length ){
        blockSlider.flickity({ // options
            cellSelector: '.carousel-slide',
            prevNextButtons: false,
            wrapAround: true,
            pageDots: false,
        });
    }

    if( specialsSlider.length ){
        specialsSlider.flickity({ // options
            cellSelector: '.specials-slide',
            prevNextButtons: false,
            wrapAround: true,
            pageDots: false,
        });

        jQuery( '.flickity-previous' ).on( 'click', function( e ){
            e.preventDefault();
            specialsSlider.flickity('previous');
        });
        jQuery( '.flickity-next' ).on( 'click', function( e ){
            e.preventDefault();
            specialsSlider.flickity('next');
        });
    }

    if( headerSlider.length ){
        headerSlider.flickity({ // options
            cellSelector: '.carousel-slide',
            prevNextButtons: false,
            wrapAround: true,
            pageDots: true,
            prevNextButtons: true,
            arrowShape: 'M73.51,100a3,3,0,0,0,2-.84,2.4,2.4,0,0,0,0-3.65L30,50,75.47,4.49a2.4,2.4,0,0,0,0-3.65,2.4,2.4,0,0,0-3.65,0L24.63,48a2.4,2.4,0,0,0,0,3.65L71.82,98.88A1.75,1.75,0,0,0,73.51,100Z',
        });
    }
};

/* STICKY HEADER
 *
 * */
var stickyHeader = function(){
    var header = jQuery( '.header' ),
        topBar = jQuery( '.top-bar' );

    // header.height( header.height() );
    header.height( topBar.height() );
    jQuery( '#top-bar-menu' ).addClass( 'sticky' );
};

/* SPECIALS FUNCTIONALITY
 *
 * */
function specialsOverlays(){
    jQuery( '.special-details-link' ).on( 'click', function( e ){
        var overlay = jQuery( this ).siblings().closest( '.special-overlay' );

        if( !overlay.hasClass( 'open' ) ){
            jQuery( '.special-overlay' ).removeClass( 'open' ).slideUp();
            overlay.slideDown().addClass( 'open' );
        }else{
            jQuery( '.special-overlay' ).removeClass( 'open' ).slideUp();
        }
    });
    jQuery( '.special-overlay-close' ).on( 'click', function( e ){
        jQuery( '.special-overlay' ).removeClass( 'open' ).slideUp();
    });
};

/* EVENT CATEGORY PICKER
 *
 * */
function setUpEventCategories(){
    jQuery( 'select.selectric' ).selectric().on('change', function() {
        filterCategory( jQuery( this ).val() );
    });
};

function filterCategory( categoryID ){

    categoryID = parseInt( categoryID);

    var eventsGrid = jQuery( '.events-grid-block .event' ),
        event = jQuery( this ),
        inCategory;

    eventsGrid.each( function(){
        inCategory = jQuery.inArray( categoryID, jQuery( this ).data( 'event-categories' ) );

        console.log( categoryID );
        if( categoryID == '0' || inCategory > -1 ){
            jQuery( this ).show();
        }else{
            jQuery( this ).hide();
        }
    });

}

// Date Pickers
const flatpickrOptions = {
    // mode: "range",
    minDate: "today",
    // dateFormat: "Y-m-d",
    dateFormat: "m/d/Y",
};

const datePickerStart = flatpickr('[data-date-picker]', flatpickrOptions);


// Set-up Page
var setupPage = function(){

    stickyHeader();
    setUpSliders();
    specialsOverlays();
    setUpEventCategories();

}

jQuery( document ).ready( setupPage );
jQuery( window ).on( 'resize', stickyHeader );

var bookingForm = document.getElementById('resform');
var hotelIdField = document.getElementById('hotel-id');

var setBookingFormAction = function(hotelId) {
  var baseURL = bookingForm.getAttribute('data-base-url');

  bookingForm.action = baseURL + hotelId;
}

if (bookingForm && hotelIdField) {
  hotelIdField.addEventListener('change', function(e) {
    var hotelId = (e.target.value || e.target.options[e.target.selectedIndex].value);  //crossbrowser solution =)
    setBookingFormAction(hotelId);
  })
}

jQuery('#resform select.selectric').on('change', function(e) {
  var hotelId = (e.target.value || e.target.options[e.target.selectedIndex].value);  //crossbrowser solution =)
  setBookingFormAction(hotelId);
});

// jQuery('select.selectric').selectric().on('change', function() {
//     filterCategory( jQuery( this ).val() );
// });
